var map = {
	"./bounce.svg": "c44c",
	"./fadeIn.svg": "ca19",
	"./flash.svg": "f50a",
	"./ignore.svg": "403e",
	"./pulse.svg": "62f2",
	"./shake.svg": "c710",
	"./slideIn.svg": "a8ec",
	"./zoomIn.svg": "63ef"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "afd2";